
(function () {
  if (window.__bhCustomerSync) return;
  window.__bhCustomerSync = true;

  var cfgEl = document.getElementById('bh-customer-sync-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }
  if (!CFG.walletBase || !CFG.publicKey) return;

  var liquidCid = String(CFG.liquidCustomerId || '').trim();
  var seedWishlist = Array.isArray(CFG.seedWishlist) ? CFG.seedWishlist : [];
  var seedCart = Array.isArray(CFG.seedCart) ? CFG.seedCart : [];

  function resolve() {
    var capiCid = String(window.bhCapiCustomerId || '').trim();
    var capiTok = String(window.bhCapiAccessToken || '').trim();
    if (capiCid && capiTok) {
      return { customerId: capiCid, capiToken: capiTok, source: 'capi' };
    }
    if (liquidCid) {
      return { customerId: liquidCid, capiToken: '', source: 'classic' };
    }
    return null;
  }

  function api(method, path, body, ctx, opts) {
    var headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-bh-wallet-key': CFG.publicKey,
    };
    if (ctx && ctx.capiToken) {
      headers['Authorization'] = 'Bearer ' + ctx.capiToken;
    }
    var init = { method: method, credentials: CFG.liquidCustomerId ? 'include' : 'omit', headers: headers };
    if (body !== undefined) init.body = JSON.stringify(body);
    if (opts && opts.keepalive) init.keepalive = true;
    return fetch(CFG.walletBase + path, init)
      .then(function (r) {
        if (!r.ok) return null;
        return r.json().catch(function () { return null; });
      })
      .catch(function () { return null; });
  }

  function debounce(fn, ms) {
    var t = null;
    return function () {
      var args = arguments;
      var self = this;
      if (t) clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms);
    };
  }

  function pushWishlist(ctx) {
    if (!window.BHWishlist || !ctx) return Promise.resolve();
    var local = window.BHWishlist.list() || [];
    var payload = local.map(function (it) {
      var entry = { product_id: String(it.id) };
      if (it.variant) entry.variant_id = String(it.variant);
      if (it.handle) entry.handle = it.handle;
      entry.added_at = it.added_at || Math.floor(Date.now() / 1000);
      return entry;
    });
    var p = api('POST', '/api/wallet/customer/wishlist',
        { customer_id: ctx.customerId, items: payload }, ctx);
    window.__bhPushWishlistPending = p.then(function () {
      window.__bhPushWishlistPending = null;
    }, function () {
      window.__bhPushWishlistPending = null;
    });
    return window.__bhPushWishlistPending;
  }

  function fetchWishlistSeed(ctx) {
    function liquidFallback() {
      if (ctx.source === 'classic' && seedWishlist && seedWishlist.length > 0) {
        return seedWishlist;
      }
      return null;
    }
    return api('GET',
      '/api/wallet/customer/wishlist?customer_id=' + encodeURIComponent(ctx.customerId),
      undefined, ctx
    ).then(function (j) {
      if (!j || j.ok === false) return liquidFallback();
      return Array.isArray(j.items) ? j.items : [];
    }, function () {
      return liquidFallback();
    });
  }

  function hydrateWishlist(ctx, attempt) {
    if (!window.BHWishlist) {
      attempt = attempt || 0;
      if (attempt >= 25) return; // give up after ~5s; mutations still sync on their own
      setTimeout(function () { hydrateWishlist(ctx, attempt + 1); }, 200);
      return;
    }
    var pending = window.__bhPushWishlistPending || Promise.resolve();
    pending.then(function () { runWishlistHydrate(ctx); });
  }

  function runWishlistHydrate(ctx) {
    fetchWishlistSeed(ctx).then(function (seed) {
      if (seed === null) {
        return;
      }
      var remoteIds = seed.map(function (item) {
        var pid = parseInt(item.product_id, 10);
        if (!pid) return null;
        return {
          id: pid,
          variant: item.variant_id ? parseInt(item.variant_id, 10) : null,
          handle: (item.handle && typeof item.handle === 'string') ? item.handle : '',
        };
      }).filter(Boolean);
      try {
        var __freshCutoff = Date.now() - 15000;
        var __localNow = window.BHWishlist.list() || [];
        var __remoteSet = {};
        remoteIds.forEach(function (r) { __remoteSet[r.id] = true; });
        __localNow.forEach(function (it) {
          var pid = parseInt(it.id, 10);
          var added = parseInt(it.added_at, 10) || 0;
          if (pid && !__remoteSet[pid] && added >= __freshCutoff) {
            remoteIds.push({ id: pid, variant: it.variant || null, handle: it.handle || '' });
          }
        });
      } catch (e) {}
      try {
        var __mut = window.__bhRecentWishlistMutations || {};
        var __cut = Date.now() - 15000;
        remoteIds = remoteIds.filter(function (r) {
          var m = __mut[r.id];
          return !(m && m.type === 'remove' && m.ts >= __cut);
        });
      } catch (e) {}
      window.__bhSyncSilenceWishlistPush = true;
      try {
        window.BHWishlist.applyFromApp(remoteIds);
      } catch (e) {}
      setTimeout(function () {
        window.__bhSyncSilenceWishlistPush = false;
      }, 500);
    });
  }

  var lastCartSig = '';
  var cartDirty = false;
  var lastCartCtx = null;
  var LOCAL_NEWER_KEY = 'bh_cart_local_newer_v1';
  function markLocalNewer() {
    try { sessionStorage.setItem(LOCAL_NEWER_KEY, '1'); } catch (e) {}
  }
  function clearLocalNewer() {
    try { sessionStorage.removeItem(LOCAL_NEWER_KEY); } catch (e) {}
  }
  function hasLocalNewer() {
    try { return sessionStorage.getItem(LOCAL_NEWER_KEY) === '1'; } catch (e) { return false; }
  }
  if (!window.__bhCartNavWatch) {
    window.__bhCartNavWatch = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (a && /\/cart\/(change|clear)/.test(a.getAttribute('href') || '')) markLocalNewer();
    }, true);
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.action && /\/cart(\/|\?|$)/.test(String(f.action))) markLocalNewer();
    }, true);
  }

  function fetchLocalCart() {
    return fetch('/cart.js', {
      credentials: 'include',
      headers: { Accept: 'application/json' },
    }).then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function pushCartSnapshot(ctx, opts) {
    if (!ctx) return;
    lastCartCtx = ctx;
    return fetchLocalCart().then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      var lines = cart.items.map(function (it) {
        var entry = {
          variant_id: String(it.variant_id),
          quantity: it.quantity,
          updated_at: Math.floor(Date.now() / 1000),
        };
        if (it.product_id) entry.product_id = String(it.product_id);
        if (it.properties && Object.keys(it.properties).length > 0) {
          entry.properties = it.properties;
        }
        return entry;
      });
      var sig = JSON.stringify(
        lines.map(function (l) { return l.variant_id + '×' + l.quantity; }).sort()
      );
      if (sig === lastCartSig) { cartDirty = false; clearLocalNewer(); return; }
      lastCartSig = sig;
      return api('POST', '/api/wallet/customer/cart',
          { customer_id: ctx.customerId, lines: lines }, ctx, opts)
        .then(function (r) {
          if (r && r.ok !== false) { cartDirty = false; clearLocalNewer(); }
        });
    });
  }

  function flushCartPush() {
    if (!cartDirty || !lastCartCtx) return;
    try { pushCartSnapshot(lastCartCtx, { keepalive: true }); } catch (e) {}
  }
  if (!window.__bhCartFlushBound) {
    window.__bhCartFlushBound = true;
    window.addEventListener('pagehide', flushCartPush);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flushCartPush();
    });
  }

  function fetchCartSeed(ctx) {
    if (ctx.source === 'classic') {
      if (seedCart && seedCart.length > 0) {
        return Promise.resolve(seedCart);
      }
    }
    return api('GET',
      '/api/wallet/customer/cart?customer_id=' + encodeURIComponent(ctx.customerId),
      undefined, ctx
    ).then(function (j) {
      if (!j || j.ok === false) return null;
      return Array.isArray(j.lines) ? j.lines : [];
    });
  }

  function hydrateCart(ctx) {
    if (hasLocalNewer()) {
      lastCartSig = '';
      cartDirty = true;
      pushCartSnapshot(ctx);
      return;
    }
    fetchCartSeed(ctx).then(function (seed) {
      if (seed === null) return; // API failure — leave local alone

      fetchLocalCart().then(function (cart) {
        var localByVid = {};
        if (cart && Array.isArray(cart.items)) {
          cart.items.forEach(function (it) {
            if (it.variant_id) localByVid[String(it.variant_id)] = it;
          });
        }
        var seedByVid = {};
        seed.forEach(function (line) {
          var vid = String(line.variant_id);
          if (vid && vid !== '0') seedByVid[vid] = line;
        });

        var ops = []; // serialised fetch ops against /cart/*

        Object.keys(localByVid).forEach(function (vid) {
          if (!seedByVid[vid]) {
            var key = localByVid[vid].key;
            ops.push(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: key, quantity: 0 }),
              }).catch(function () {});
            });
          }
        });

        Object.keys(seedByVid).forEach(function (vid) {
          if (cartDirty) return;
          if (!localByVid[vid]) {
            var line = seedByVid[vid];
            ops.push(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: parseInt(vid, 10), quantity: line.quantity }),
              }).catch(function () {});
            });
          }
        });

        Object.keys(seedByVid).forEach(function (vid) {
          var localLine = localByVid[vid];
          var seedLine = seedByVid[vid];
          if (localLine && localLine.quantity !== seedLine.quantity) {
            var key = localLine.key;
            var qty = seedLine.quantity;
            ops.push(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: key, quantity: qty }),
              }).catch(function () {});
            });
          }
        });

        if (ops.length === 0) return; // already in sync — no work
        window.__bhSyncSilenceCartPush = true;
        var p = Promise.resolve();
        ops.forEach(function (fn) { p = p.then(fn); });
        p.then(function () {
          setTimeout(function () {
            window.__bhSyncSilenceCartPush = false;
          }, 500);
        });
      });
    });
  }

  if (!window.__bhCustomerSyncCartObserver) {
    window.__bhCustomerSyncCartObserver = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = (typeof url === 'string') ? url
        : (url && url.url) ? url.url : '';
      var isMutation = /\/cart\/(add|change|update|clear)/.test(urlStr);
      var p = origFetch.apply(this, arguments);
      if (isMutation && !window.__bhSyncSilenceCartPush) {
        cartDirty = true;
        markLocalNewer();
        p.then(function () {
          var ctx = resolve();
          if (ctx && window.__bhDebouncedCartPush) {
            window.__bhDebouncedCartPush(ctx);
          }
        }, function () {});
      }
      return p;
    };
  }

  document.addEventListener('bh:wishlist:change', function (e) {
    try {
      var __det = (e && e.detail) || {};
      var __mid = parseInt(__det.id, 10);
      if (__mid && (__det.action === 'add' || __det.action === 'remove')) {
        window.__bhRecentWishlistMutations = window.__bhRecentWishlistMutations || {};
        window.__bhRecentWishlistMutations[__mid] = { type: __det.action, ts: Date.now() };
      }
    } catch (e2) {}
    if (window.__bhSyncSilenceWishlistPush) return;
    var ctx = resolve();
    if (!ctx) return;
    pushWishlist(ctx);
  });

  function bindDebouncers(ctx) {
    if (!window.__bhDebouncedCartPush) {
      window.__bhDebouncedCartPush = debounce(function (c) {
        pushCartSnapshot(c);
      }, 400);
    }
  }

  var OWNER_KEY = 'bh_wishlist_owner_v1';
  function readOwner() { try { return localStorage.getItem(OWNER_KEY) || ''; } catch (e) { return ''; } }
  function writeOwner(val) {
    try { if (val) localStorage.setItem(OWNER_KEY, val); else localStorage.removeItem(OWNER_KEY); } catch (e) {}
  }
  function wishlistOwnerLifecycle(ctx, attempt) {
    if (!window.BHWishlist || typeof window.BHWishlist.clearLocalSilent !== 'function') {
      attempt = attempt || 0;
      if (attempt >= 25) return; // module never loaded; badges aren't rendered either
      setTimeout(function () { wishlistOwnerLifecycle(ctx, attempt + 1); }, 200);
      return;
    }
    var prev = readOwner();
    var curr = ctx ? String(ctx.customerId) : '';
    if (curr) {
      if (prev && prev !== curr) {
        window.BHWishlist.clearLocalSilent();
      } else if (!prev && (window.BHWishlist.count() || 0) > 0) {
        pushWishlist(ctx);
      }
      writeOwner(curr);
    } else if (prev) {
      writeOwner('');
      window.BHWishlist.clearLocalSilent();
    }
  }

  function flagAppUser(ctx) {
    if (!ctx || !document.documentElement.classList.contains('in-app')) return;
    var KEY = 'bh_app_flagged_v1';
    try { if (localStorage.getItem(KEY) === String(ctx.customerId)) return; } catch (e) {}
    api('POST', '/api/wallet/customer/app-flag', { customer_id: ctx.customerId }, ctx)
      .then(function (r) {
        if (r && r.ok) { try { localStorage.setItem(KEY, String(ctx.customerId)); } catch (e) {} }
      });
  }

  function bootstrap() {
    var ctx = resolve();
    if (!ctx) return false;
    bindDebouncers(ctx);
    flagAppUser(ctx);
    wishlistOwnerLifecycle(ctx);
    hydrateWishlist(ctx);
    hydrateCart(ctx);
    return true;
  }

  var attempts = 0;
  function tick() {
    if (window.__bhCustomerSyncBootstrapped) return;
    if (bootstrap()) {
      window.__bhCustomerSyncBootstrapped = true;
      return;
    }
    attempts++;
    if (attempts === 1 && !document.documentElement.classList.contains('in-app')) {
      wishlistOwnerLifecycle(null);
    }
    if (attempts < 25) setTimeout(tick, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }

  window.__bhCustomerSyncRehydrate = function () {
    window.__bhCustomerSyncBootstrapped = false;
    attempts = 0;
    tick();
  };
})();
